/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SonicOrderMessage = {
    readonly id?: number;
    status?: SonicOrderMessage.status;
    /**
     * Optional reason for error status
     */
    error_reason?: string | null;
    duplicate_case?: number | null;
    emr_identity?: SonicOrderMessage.emr_identity | null;
    readonly created_at?: string;
}

export namespace SonicOrderMessage {

    export enum status {
        PENDING = 'pending',
        SUCCESS = 'success',
        ERROR = 'error',
        HOLD = 'hold',
        DROPPED = 'dropped',
    }

    export enum emr_identity {
        ATHENA = 'ATHENA',
        COPATH = 'COPATH',
        ECW = 'ECW',
        MODMED = 'MODMED',
        NEXTECH = 'NEXTECH',
        WPL = 'WPL',
    }


}
